import React from "react";

class TextSection extends React.Component {
  render() {
    // console.log(this.props);
    return (
      <div>
        <strong>{this.props.title}</strong>
        <p>{this.props.text}</p>
      </div>
    );
  }
}

export default TextSection;
